export default "__VITE_ASSET__7cfc6c02__"